var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.5H18V20.5C18 18.8431 16.6569 17.5 15 17.5H9C7.34315 17.5 6 18.8431 6 20.5V22.5H4V20.5C4 17.7386 6.23858 15.5 9 15.5H15C17.7614 15.5 20 17.7386 20 20.5V22.5ZM12 13.5C8.68629 13.5 6 10.8137 6 7.5C6 4.18629 8.68629 1.5 12 1.5C15.3137 1.5 18 4.18629 18 7.5C18 10.8137 15.3137 13.5 12 13.5ZM12 11.5C14.2091 11.5 16 9.70914 16 7.5C16 5.29086 14.2091 3.5 12 3.5C9.79086 3.5 8 5.29086 8 7.5C8 9.70914 9.79086 11.5 12 11.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLine);
export default __webpack_public_path__ + "static/media/account-line.042962a740af416ec1ff3aa9af9ce45f.svg";
export { ForwardRef as ReactComponent };